import { Typography } from '@material-ui/core';
import {
  FormikContextTypeEnhanced,
  FormikTextField,
} from '@superdispatch/forms';
import { Column, Columns, Inline, Stack } from '@superdispatch/ui';
import { APIResponse } from 'shared/api/CarrierAPIClient';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { FormikMediaField } from 'shared/form/FormikMediaField';
import { useACHPaymentInfo } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';
import { ACHPaymentInfoDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';
import { PermissionButton } from 'shared/modules/permission/core/PermissionButton';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { ProfilePageLayout } from '../ProfilePageLayout';

export function ACHFormView({
  formik,
}: {
  formik: FormikContextTypeEnhanced<ACHPaymentInfoDTO, APIResponse>;
}) {
  const { isLoading } = useACHPaymentInfo();
  const { data: settings } = useCarrierSettings();

  const isEditingDisabled =
    !settings?.drivers_can_edit_carrier_info && MobileAppBridge.isInjected();

  return (
    <ProfilePageLayout
      formik={formik}
      title="ACH Payment Info"
      isLoading={isLoading}
      actions={
        <Inline horizontalAlign="right" space="small">
          <PermissionButton
            name="ach_payment_info"
            permission="can_edit"
            type="button"
            onClick={() => {
              void formik.submitForm();
            }}
            pending={formik.isSubmitting}
            disabled={!formik.dirty}
            fullWidth={isWebView}
          >
            Save
          </PermissionButton>
        </Inline>
      }
    >
      <Stack space="small">
        <Typography color="textSecondary" gutterBottom={true}>
          ACH Payment Info helps Shippers to process payments faster.
          <br />
          Shippers can see this information. Drivers can see and edit this
          information
        </Typography>

        <FormikTextField
          label="Bank Name"
          name="bank_name"
          fullWidth={true}
          disabled={isEditingDisabled}
        />

        <Columns space="small" collapseBelow="tablet">
          <Column>
            <FormikTextField
              label="Routing Number"
              name="bank_routing_number"
              fullWidth={true}
              disabled={isEditingDisabled}
            />
          </Column>
          <Column>
            <FormikTextField
              label="Bank Account Number"
              name="bank_account_number"
              fullWidth={true}
              disabled={isEditingDisabled}
            />
          </Column>
        </Columns>

        <FormikMediaField
          label="Voided Check Upload"
          name="voided_check_url"
          isRestricted={true}
          disabled={isEditingDisabled}
        />
      </Stack>
    </ProfilePageLayout>
  );
}
